module.exports = __webpack_public_path__ + "static/media/How to delete stagewise templated invoice.bcf89fa2.png";